<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 5.39271V9.89271C22.5 10.0916 22.421 10.2824 22.2803 10.423C22.1397 10.5637 21.9489 10.6427 21.75 10.6427H17.25C17.0511 10.6427 16.8603 10.5637 16.7197 10.423C16.579 10.2824 16.5 10.0916 16.5 9.89271C16.5 9.6938 16.579 9.50303 16.7197 9.36238C16.8603 9.22173 17.0511 9.14271 17.25 9.14271H19.8188L17.3259 6.85896L17.3025 6.83646C16.2601 5.79442 14.9337 5.08264 13.4891 4.79004C12.0445 4.49743 10.5457 4.63698 9.17991 5.19124C7.81414 5.74551 6.64197 6.68991 5.80982 7.90649C4.97768 9.12306 4.52245 10.5579 4.501 12.0317C4.47956 13.5054 4.89286 14.9529 5.68926 16.1932C6.48566 17.4334 7.62986 18.4115 8.97892 19.0053C10.328 19.5991 11.8221 19.7822 13.2746 19.5317C14.7271 19.2813 16.0736 18.6084 17.1459 17.5971C17.2905 17.4603 17.4835 17.3866 17.6825 17.3922C17.8814 17.3977 18.07 17.482 18.2067 17.6266C18.3435 17.7712 18.4172 17.9642 18.4117 18.1631C18.4061 18.3621 18.3218 18.5506 18.1772 18.6874C16.5098 20.2687 14.298 21.1479 12 21.1427H11.8763C10.4023 21.1225 8.95579 20.7406 7.66398 20.0305C6.37216 19.3203 5.27455 18.3037 4.46762 17.0701C3.6607 15.8364 3.16915 14.4234 3.0362 12.9553C2.90324 11.4872 3.13294 10.0089 3.70511 8.6503C4.27728 7.29173 5.1744 6.09451 6.31762 5.16386C7.46085 4.23321 8.81517 3.59762 10.2616 3.31296C11.7079 3.02829 13.2021 3.10327 14.6127 3.53129C16.0234 3.95932 17.3073 4.72729 18.3516 5.76771L21 8.18646V5.39271C21 5.1938 21.079 5.00303 21.2197 4.86238C21.3603 4.72173 21.5511 4.64271 21.75 4.64271C21.9489 4.64271 22.1397 4.72173 22.2803 4.86238C22.421 5.00303 22.5 5.1938 22.5 5.39271Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsArrowClockWise'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
